import { render } from "./ListInvoice.vue?vue&type=template&id=05d4cfe6"
import script from "./ListInvoice.vue?vue&type=script&lang=ts"
export * from "./ListInvoice.vue?vue&type=script&lang=ts"
script.render = render

export default script